import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import API, { getServerTimeApi } from "../../Api/api";
import { TERMS_POINTS, TERMS_TITLE } from "../Terms/termsContent";
import logo from "../../Assets/dbskillslogo.png";

const Icon = ({ d, size = 18, color = "currentColor", fill = "none", strokeWidth = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={fill} stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);
const IconLogout   = (p) => <Icon {...p} d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />;
const IconClock    = (p) => <Icon {...p} d="M12 2a10 10 0 1 0 0 20A10 10 0 0 0 12 2zM12 6v6l4 2" />;
const IconCalendar = (p) => <Icon {...p} d="M3 4h18v18H3zM16 2v4M8 2v4M3 10h18" />;
const IconArrowR   = (p) => <Icon {...p} d="M5 12h14M12 5l7 7-7 7" />;
const IconArrowL   = (p) => <Icon {...p} d="M19 12H5M12 19l-7-7 7-7" />;
const IconPin      = (p) => <Icon {...p} d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z M12 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />;

const fmtTime = (t) =>
  t ? new Date(t).toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit", hour12: true }) : null;

// ─── Check Card ──────────────────────────────────────────────────────────
const CheckCard = ({ label, time, status, statusLabel, done, onClick, isIn }) => (
  <div
    onClick={!done ? onClick : undefined}
    style={{ flex:1, background:"#fff", borderRadius:20, padding:15, boxShadow:"0 2px 12px rgba(0,0,0,0.07)", cursor:done?"default":"pointer", opacity:done?0.85:1, transition:"transform 0.15s", userSelect:"none" }}
    onMouseEnter={e => { if (!done) e.currentTarget.style.transform = "translateY(-2px)"; }}
    onMouseLeave={e => { e.currentTarget.style.transform = "none"; }}
  >
    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
      <div style={{ width:32, height:32, borderRadius:"50%", background:"#06B6D4", display:"flex", alignItems:"center", justifyContent:"center" }}>
        {isIn ? <IconArrowR size={14} color="#fff" /> : <IconArrowL size={14} color="#fff" />}
      </div>
      <p style={{ fontSize:14, fontWeight:600, color:"#111" }}>{label}</p>
      <div style={{ width:32, height:32, borderRadius:"50%", background:"#F2F2F2", display:"flex", alignItems:"center", justifyContent:"center" }}>
        <span style={{ fontSize:16, color:"#555" }}>···</span>
      </div>
    </div>
    <p style={{ fontSize:26, fontWeight:800, color:"#111", letterSpacing:2, margin:"6px 0 10px" }}>{time || "--:--"}</p>
    <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
      <span style={{ padding:"3px 10px", borderRadius:20, fontSize:11, fontWeight:600, background:done?"#D1FAE5":"#FEF3C7", color:done?"#059669":"#D97706" }}>
        {done ? "Success" : "Pending"}
      </span>
      {statusLabel && (
        <span style={{ padding:"3px 9px", borderRadius:20, fontSize:10, fontWeight:700, background:status==="OnTime"?"#DBEAFE":"#FEE2E2", color:status==="OnTime"?"#1D4ED8":"#DC2626" }}>
          {statusLabel}
        </span>
      )}
    </div>
  </div>
);

// ─── Attendance Card ─────────────────────────────────────────────────────
const AttCard = ({ item }) => {
  const onTime = item.status === "OnTime";
  return (
    <div style={{ width:160, flexShrink:0, background:"#fff", borderRadius:16, overflow:"hidden", boxShadow:"0 2px 10px rgba(0,0,0,0.07)" }}>
      <div style={{ height:4, background: onTime ? "#06B6D4" : "#F97316" }} />
      <div style={{ padding:"10px 12px 12px" }}>
        <p style={{ fontSize:11, fontWeight:700, color:"#555", marginBottom:8, letterSpacing:0.3 }}>{item.date}</p>
        <div style={{ display:"flex", gap:8, marginBottom:10 }}>
          <div style={{ flex:1 }}>
            <p style={{ fontSize:9, fontWeight:800, color:"#AAA", letterSpacing:0.8, marginBottom:2 }}>IN</p>
            <p style={{ fontSize:12, fontWeight:800, color:"#111" }}>{item.checkIn || "--:--"}</p>
          </div>
          <div style={{ width:1, background:"#F0F0F0" }} />
          <div style={{ flex:1 }}>
            <p style={{ fontSize:9, fontWeight:800, color:"#AAA", letterSpacing:0.8, marginBottom:2 }}>OUT</p>
            <p style={{ fontSize:12, fontWeight:800, color:"#111" }}>{item.checkOut || "--:--"}</p>
          </div>
        </div>
        <span style={{ padding:"3px 9px", borderRadius:20, fontSize:10, fontWeight:800, background:onTime?"#DBEAFE":"#FEE2E2", color:onTime?"#1D4ED8":"#DC2626" }}>
          {onTime ? "On Time" : item.status === "Absent" ? "Absent" : "Late"}
        </span>
      </div>
    </div>
  );
};

// ─── Leave Chip ───────────────────────────────────────────────────────────
const LeaveChip = ({ item }) => {
  const cfg = {
    pending:  { bg:"#FEF3C7", text:"#D97706", dot:"#F59E0B" },
    approved: { bg:"#D1FAE5", text:"#059669", dot:"#10B981" },
    rejected: { bg:"#FEE2E2", text:"#DC2626", dot:"#EF4444" },
  }[item.status] || { bg:"#FEF3C7", text:"#D97706", dot:"#F59E0B" };
  return (
    <div style={{ width:130, flexShrink:0, background:"#fff", borderRadius:16, padding:12, boxShadow:"0 2px 10px rgba(0,0,0,0.07)" }}>
      <div style={{ width:36, height:36, borderRadius:10, background:"rgba(6,182,212,0.1)", display:"flex", alignItems:"center", justifyContent:"center", marginBottom:8 }}>
        <IconCalendar size={18} color={cfg.dot} />
      </div>
      <p style={{ fontSize:13, fontWeight:800, color:"#111", marginBottom:3 }}>{item.type}</p>
      <p style={{ fontSize:10, color:"#999", marginBottom:3 }}>{item.from} — {item.to}</p>
      <p style={{ fontSize:17, fontWeight:900, color:"#0D1B2A", marginBottom:8 }}>{item.days}d</p>
      <div style={{ display:"inline-flex", alignItems:"center", gap:4, background:cfg.bg, padding:"3px 9px", borderRadius:20 }}>
        <div style={{ width:5, height:5, borderRadius:"50%", background:cfg.dot }} />
        <span style={{ fontSize:10, fontWeight:800, color:cfg.text }}>
          {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
        </span>
      </div>
    </div>
  );
};

const SectionHeader = ({ title, onSeeAll }) => (
  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
    <div style={{ display:"flex", alignItems:"center", gap:8 }}>
      <div style={{ width:4, height:18, borderRadius:2, background:"#06B6D4" }} />
      <p style={{ fontSize:16, fontWeight:800, color:"#111" }}>{title}</p>
    </div>
    <button onClick={onSeeAll} style={{ background:"none", border:"none", cursor:"pointer", display:"flex", alignItems:"center", gap:2, color:"#06B6D4", fontSize:13, fontWeight:600 }}>
      See All <span style={{ fontSize:16 }}>›</span>
    </button>
  </div>
);

const ViewAllBtn = ({ onClick }) => (
  <div onClick={onClick} style={{ width:64, flexShrink:0, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:6, cursor:"pointer" }}>
    <div style={{ width:40, height:40, borderRadius:"50%", background:"rgba(6,182,212,0.1)", display:"flex", alignItems:"center", justifyContent:"center" }}>
      <span style={{ color:"#06B6D4", fontSize:20 }}>›</span>
    </div>
    <p style={{ fontSize:11, fontWeight:700, color:"#06B6D4", textAlign:"center" }}>View All</p>
  </div>
);

const LiveMap = ({ location, locError, locLoading }) => {
  const mapSrc = location
    ? `https://maps.google.com/maps?q=${location.lat},${location.lng}&z=16&output=embed`
    : null;
  return (
    <div style={{ height:155, borderRadius:20, overflow:"hidden", marginBottom:22, position:"relative", background:"#F1F5F9" }}>
      {mapSrc && <iframe src={mapSrc} title="Your Location" style={{ width:"100%", height:"100%", border:"none", display:"block" }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />}
      {locLoading && !mapSrc && (
        <div style={{ position:"absolute", inset:0, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:8 }}>
          <div style={{ width:26, height:26, border:"3px solid rgba(6,182,212,0.2)", borderTopColor:"#06B6D4", borderRadius:"50%", animation:"spin 0.8s linear infinite" }} />
          <p style={{ fontSize:12, color:"#9CA3AF", fontWeight:500 }}>Fetching location…</p>
        </div>
      )}
      {locError && !mapSrc && (
        <div style={{ position:"absolute", inset:0, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:8 }}>
          <IconPin size={24} color="#D1D5DB" />
          <p style={{ fontSize:12, color:"#9CA3AF", fontWeight:500 }}>{locError}</p>
        </div>
      )}
      {location && (
        <div style={{ position:"absolute", bottom:10, left:10, background:"rgba(255,255,255,0.92)", borderRadius:20, padding:"4px 10px", display:"flex", alignItems:"center", gap:5, boxShadow:"0 2px 8px rgba(0,0,0,0.15)", pointerEvents:"none" }}>
          <IconPin size={11} color="#06B6D4" />
          <span style={{ fontSize:10, fontWeight:600, color:"#374151" }}>{location.lat.toFixed(5)}, {location.lng.toFixed(5)}</span>
        </div>
      )}
    </div>
  );
};

const EmptyBox = ({ text }) => (
  <div style={{ display:"flex", flexDirection:"column", alignItems:"center", padding:"28px 0 16px", gap:8 }}>
    <IconCalendar size={28} color="#ccc" />
    <p style={{ fontSize:12, color:"#bbb" }}>{text}</p>
  </div>
);

// ─── Main ─────────────────────────────────────────────────────────────────
export default function Dashboard() {
  const navigate = useNavigate();
  const [serverOffset, setServerOffset] = useState(0);
  const [now,          setNow]          = useState(new Date());
  const [attendance,   setAttendance]   = useState(null);
  const [logs,         setLogs]         = useState([]);
  const [leaves,       setLeaves]       = useState([]);
  const [profile,      setProfile]      = useState(null);
  const [loading,      setLoading]      = useState(true);
  const [refreshing,   setRefreshing]   = useState(false);
  const [menuOpen,     setMenuOpen]     = useState(false);
  const [userLocation, setUserLocation] = useState(null);
  const [locLoading,   setLocLoading]   = useState(true);
  const [locError,     setLocError]     = useState("");

  // ── Sync Server Time ─────────────────────────────────────────────
  const fetchServerTime = useCallback(async () => {
    try {
      const res = await getServerTimeApi();
      if (res) {
        // Handle server time from API response
        const serverTime = res.serverTime || res.timestamp || res.datetime || new Date().toISOString();
        const serverMs = new Date(serverTime).getTime();
        const clientMs = Date.now();
        const offset = serverMs - clientMs;
        setServerOffset(offset);
        setNow(new Date(clientMs + offset));
        return offset;
      }
    } catch (err) {
      console.log("Failed to fetch server time:", err?.message);
    }
    return 0;
  }, []);

  useEffect(() => {
    fetchServerTime();
    const serverSyncInterval = setInterval(fetchServerTime, 60000);
    return () => clearInterval(serverSyncInterval);
  }, [fetchServerTime]);

  useEffect(() => {
    const t = setInterval(() => {
      setNow(new Date(Date.now() + serverOffset));
    }, 1000);
    return () => clearInterval(t);
  }, [serverOffset]);

  useEffect(() => {
    if (!navigator.geolocation) { setLocError("Geolocation not supported"); setLocLoading(false); return; }
    navigator.geolocation.getCurrentPosition(
      (pos) => { setUserLocation({ lat: pos.coords.latitude, lng: pos.coords.longitude }); setLocLoading(false); },
      (err) => { setLocError(err.code === 1 ? "Location permission denied" : "Unable to get location"); setLocLoading(false); },
      { enableHighAccuracy: true, timeout: 12000, maximumAge: 30000 }
    );
  }, []);

  useEffect(() => { loadAll(); }, []);

  const loadAll = useCallback(async () => {
    setRefreshing(true);
    try {
      await Promise.all([fetchServerTime(), loadProfile(), loadToday(), loadAttendanceLogs(), loadLeaves()]);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  }, [fetchServerTime]);

  const loadProfile = async () => {
    try {
      const r = await API.get("/user/profile");
      if (r.data.success) setProfile(r.data.data);
    } catch {}
  };

  const loadToday = async () => {
    try {
      const r = await API.get("/attendance/today");
      if (r.data.success) setAttendance(r.data.data);
    } catch {}
  };

  const loadAttendanceLogs = async () => {
    try {
      const r = await API.get("/attendance/mine");
      if (r.data.success && Array.isArray(r.data.data) && r.data.data.length > 0) {
        const sorted = [...r.data.data].sort((a, b) => new Date(b.date) - new Date(a.date));
        setLogs(sorted.slice(0, 5).map((item) => ({
          id:       item._id,
          date:     new Date(item.date).toLocaleDateString("en-IN", { timeZone:"Asia/Kolkata", month:"short", day:"numeric" }),
          checkIn:  item.checkIn?.time
                      ? new Date(item.checkIn.time).toLocaleTimeString("en-IN", { timeZone:"Asia/Kolkata", hour:"2-digit", minute:"2-digit", hour12:true })
                      : null,
          checkOut: item.checkOut?.time
                      ? new Date(item.checkOut.time).toLocaleTimeString("en-IN", { timeZone:"Asia/Kolkata", hour:"2-digit", minute:"2-digit", hour12:true })
                      : null,
          status:   item.status || item.checkIn?.status || "Late",
        })));
      }
    } catch {}
  };

  const loadLeaves = async () => {
    try {
      const r = await API.get("/leave/my");
      if (r.data.success && Array.isArray(r.data.data)) {
        setLeaves(r.data.data.map((item) => {
          const from = new Date(item.fromDate + "T00:00:00");
          const to   = new Date(item.toDate   + "T00:00:00");
          const days = Math.ceil((to - from) / (1000 * 60 * 60 * 24)) + 1;
          return {
            id:     item._id,
            type:   item.leaveType || "Leave",
            from:   from.toLocaleDateString("en-IN", { timeZone:"Asia/Kolkata", month:"short", day:"numeric" }),
            to:     to.toLocaleDateString("en-IN",   { timeZone:"Asia/Kolkata", month:"short", day:"numeric" }),
            days:   days > 0 ? days : 1,
            status: (item.status || "pending").toLowerCase(),
          };
        }));
      }
    } catch {}
  };

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      localStorage.removeItem("token");
      navigate("/", { replace: true });
    }
  };

  const getGreeting = () => {
    const kolkataHourStr = now.toLocaleTimeString("en-IN", {
      timeZone: "Asia/Kolkata",
      hour: "numeric",
      hour12: false,
    });
    const h = parseInt(kolkataHourStr, 10) || now.getHours();
    return h < 12 ? "Good Morning" : h < 17 ? "Good Afternoon" : "Good Evening";
  };

  const liveTime = now.toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata", hour:"2-digit", minute:"2-digit", hour12:true });
  const dateStr  = now.toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata", weekday:"short", month:"short", day:"numeric", year:"numeric" });

  const checkInTime    = fmtTime(attendance?.checkIn?.time);
  const checkOutTime   = fmtTime(attendance?.checkOut?.time);
  const checkInStatus  = attendance?.status || attendance?.checkIn?.status;
  const checkOutStatus = attendance?.checkOut?.status;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800;900&display=swap');
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
        body{background:#0F172A;font-family:'Plus Jakarta Sans',sans-serif}
        .db-frame{min-height:100dvh;display:flex;align-items:flex-start;justify-content:center;background:#0F172A;padding:0}
        .db-phone{width:100%;max-width:480px;min-height:100dvh;display:flex;flex-direction:column}
        @media(min-width:520px){.db-frame{padding:24px;align-items:center}.db-phone{min-height:auto;border-radius:40px;overflow:hidden;box-shadow:0 30px 80px rgba(0,0,0,.6)}}
        .db-header{background:linear-gradient(135deg,#0F172A 0%,#1E293B 60%,#334155 100%);padding:18px 20px 40px;flex-shrink:0}
        .db-scroll{flex:1;background:#fff;border-radius:28px 28px 0 0;margin-top:-20px;overflow-y:auto;padding:24px 18px 40px}
        @media(min-width:520px){.db-scroll{border-radius:0 0 40px 40px}}
        .hscroll{display:flex;gap:12px;overflow-x:auto;padding-bottom:8px;margin-bottom:20px;scrollbar-width:none}
        .hscroll::-webkit-scrollbar{display:none}
        @keyframes spin{to{transform:rotate(360deg)}}
        .spin{animation:spin .8s linear infinite}
        .loading-wrap{flex:1;display:flex;align-items:center;justify-content:center;min-height:200px}
        .spinner-lg{width:36px;height:36px;border:3px solid rgba(6,182,212,.2);border-top-color:#06B6D4;border-radius:50%;animation:spin .8s linear infinite}
        .refresh-btn{background:none;border:none;cursor:pointer;color:rgba(255,255,255,.7);font-size:16px;padding:4px 8px;border-radius:8px;display:flex;align-items:center}
        .refresh-btn:hover{background:rgba(255,255,255,.1)}
      `}</style>

      <div className="db-frame">
        <div className="db-phone">

          {/* HEADER */}
          <div className="db-header">
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:22 }}>
              <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                <div style={{ width:42, height:42, borderRadius:12, background:"rgba(255,255,255,0.12)", display:"flex", alignItems:"center", justifyContent:"center", overflow:"hidden" }}>
                  <img src={logo} alt="logo" style={{ width:28, height:28, objectFit:"contain" }} />
                </div>
                <span style={{ color:"#fff", fontSize:17, fontWeight:700 }}>DB Skills</span>
              </div>
              <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                <button onClick={loadAll} className="refresh-btn" disabled={refreshing} title="Refresh">
                  <span className={refreshing ? "spin" : ""} style={{ display:"inline-block" }}>↻</span>
                </button>
                <div style={{ position:"relative" }}>
                  <button onClick={() => setMenuOpen(o => !o)} aria-label="Menu" style={{ width:40, height:40, borderRadius:"50%", background:"rgba(255,255,255,0.14)", border:"none", cursor:"pointer", color:"#fff", fontSize:20, fontWeight:800, lineHeight:1 }}>⋮</button>
                  {menuOpen && (
                    <>
                      <div onClick={() => setMenuOpen(false)} style={{ position:"fixed", inset:0, zIndex:40 }} />
                      <div style={{ position:"absolute", right:0, top:48, zIndex:41, width:230, background:"#fff", borderRadius:16, padding:6, boxShadow:"0 10px 30px rgba(0,0,0,0.25)" }}>
                        <div onClick={() => { setMenuOpen(false); navigate("/timestamp"); }} style={{ display:"flex", alignItems:"center", gap:12, padding:"10px 12px", borderRadius:12, cursor:"pointer" }}>
                          <div style={{ width:36, height:36, borderRadius:10, background:"rgba(6,182,212,0.12)", display:"flex", alignItems:"center", justifyContent:"center" }}>
                            <IconClock size={18} color="#06B6D4" />
                          </div>
                          <div>
                            <p style={{ fontSize:14, fontWeight:700, color:"#111" }}>Timestamp Photo</p>
                            <p style={{ fontSize:11.5, color:"#64748B" }}>Photo with date, time, location</p>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <button onClick={handleLogout} style={{ width:40, height:40, borderRadius:"50%", background:"#F97316", border:"none", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>
                  <IconLogout size={18} color="#fff" />
                </button>
              </div>
            </div>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-end" }}>
              <div>
                <p style={{ color:"#93C5FD", fontSize:14, fontWeight:500, marginBottom:4 }}>{getGreeting()} 👋</p>
                <p style={{ color:"#fff", fontSize:26, fontWeight:800, letterSpacing:-0.3 }}>{profile?.name || "Employee"}</p>
              </div>
              <div style={{ display:"flex", alignItems:"center", gap:6, background:"rgba(6,182,212,0.15)", border:"1px solid rgba(6,182,212,0.3)", borderRadius:20, padding:"6px 12px" }}>
                <IconClock size={14} color="#06B6D4" />
                <span style={{ color:"#06B6D4", fontWeight:700, fontSize:14, letterSpacing:1 }}>{liveTime}</span>
              </div>
            </div>
          </div>

          {/* BODY */}
          <div className="db-scroll">
            {loading ? (
              <div className="loading-wrap"><div className="spinner-lg" /></div>
            ) : (
              <>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
                  <p style={{ fontSize:17, fontWeight:700, color:"#111" }}>Overview</p>
                  <div style={{ display:"flex", alignItems:"center", gap:5, background:"#EDEDED", padding:"5px 10px", borderRadius:20 }}>
                    <IconCalendar size={14} color="#555" />
                    <span style={{ fontSize:12, color:"#555" }}>{dateStr}</span>
                  </div>
                </div>

                <div style={{ display:"flex", gap:12, marginBottom:18 }}>
                  <CheckCard label="Check in"  time={checkInTime}  status={checkInStatus}  statusLabel={checkInStatus==="OnTime"?"On Time":checkInStatus==="Late"?"Late":checkInStatus==="Absent"?"Absent":null}  done={!!checkInTime}  isIn onClick={() => navigate("/checkin")} />
                  <CheckCard label="Check out" time={checkOutTime} status={checkOutStatus} statusLabel={checkOutStatus==="OnTime"?"On Time":checkOutStatus?"Early":null} done={!!checkOutTime} onClick={() => navigate("/checkout")} />
                </div>

                <LiveMap location={userLocation} locError={locError} locLoading={locLoading} />

                {/* ── Attendance History ── */}
                <SectionHeader title="Your Attendance" onSeeAll={() => navigate("/attendance")} />
                {logs.length === 0
                  ? <EmptyBox text="No attendance records" />
                  : <div className="hscroll">{logs.map(item => <AttCard key={item.id} item={item} />)}<ViewAllBtn onClick={() => navigate("/attendance")} /></div>
                }

                {/* ── Leave Requests ── */}
                <SectionHeader title="Leave Requests" onSeeAll={() => navigate("/leaves")} />
                {leaves.length === 0
                  ? <EmptyBox text="No leave requests" />
                  : <div className="hscroll">{leaves.map(item => <LeaveChip key={item.id} item={item} />)}<ViewAllBtn onClick={() => navigate("/leaves")} /></div>
                }

                {/* ── Terms & Conditions (always shown) ── */}
                <div style={{ marginTop:22, padding:"16px 16px 14px", borderRadius:16, background:"rgba(6,182,212,0.07)", border:"1px solid rgba(6,182,212,0.25)" }}>
                  <p style={{ fontSize:13.5, fontWeight:800, color:"#0F172A", marginBottom:10 }}>{TERMS_TITLE}</p>
                  {TERMS_POINTS.map((t, i) => (
                    <div key={i} style={{ display:"flex", gap:8, marginBottom:i === TERMS_POINTS.length - 1 ? 0 : 8 }}>
                      <span style={{ flexShrink:0, fontSize:12, fontWeight:800, color:"#0891B2" }}>{i + 1}.</span>
                      <p style={{ fontSize:12.5, lineHeight:1.5, color:"#475569" }}>{t}</p>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}